import { Box, Button, Stack, Typography } from "@mui/material";
import useAuditStore from "./useAuditStore";

export default function PatientNav(){

    const {patient, setPatient} = useAuditStore();

    return (
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{py: 0.5}}>

            {patient > 0 ? 
                <Button onClick={() =>setPatient(patient - 1)} sx={sx}>
                    Précédent
                </Button> 
                : 
                <Box sx={sx}></Box>
            }

            <Typography><b>Patient {patient + 1}</b></Typography>

            {patient < 9 ? 
                <Button onClick={() => setPatient(patient + 1)} sx={sx}>
                    Suivant
                </Button> 
                : 
                <Box sx={sx}></Box>
            }

        </Stack>
    )
}

const sx = {width: 100}